export const LOAD_CASH_REQUEST_APPROVALS = "LOAD_CASH_REQUEST_APPROVALS"
export const loadCashRequestApprovalsAction = pagination => ({
   type: LOAD_CASH_REQUEST_APPROVALS,
   payload: pagination
})